export const state = {
  filters: {
    categories: [],
    currentCategory: '',
    currentGroup: '',
    data: {},
    id: '',
    params: {},
    values: {},
    isExportDetail: false
  }
};
